import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const TableService = {
  create: async (data) => {
    const response = await apiService.post(`/${slug}/tables`, data);
    return response.data;
  },
  getList: async () => {
    const response = await apiService.get(`/${slug}/tables`);
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiService.put(`/${slug}/tables/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/tables/${id}`);
    return response.data;
  },
  getActiveTableList: async () => {
    const response = await apiService.get(`/${slug}/tables/getactivetablelist`);
    return response.data;
  },
  getActiveTableDetail: async ({ tableId }) => {
    try {
      const response = await apiService.get(
        `/${slug}/tables/getactivetable/${tableId}`
      );
      console.log(response);
      return response.data[0];
    } catch (err) {
      console.log("error: ", err);
      throw new Error(err);
    }
  },
  switchtable: async (orderRef,newTableId) => {
    const response = await apiService.put(
      `/${slug}/menuorder/update-table?orderRef=${orderRef}&newTableId=${newTableId}`
    );
    return response.data;
  },
};

export default TableService;
